import React, { useState } from "react";
import InputTags from "../../Molecules/InputTags";
import projectService from '../../../services/Projects/ProjectService';
import { useKeycloak } from "@react-keycloak/web";
import Swal from "sweetalert2";

export default function InviteMembersModal({ isOpen, onClose, projectId }) {
  const [emails, setEmails] = useState([]);
  const { keycloak } = useKeycloak();
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const styles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1000,
    },
    modal: {
      backgroundColor: "#1e1e1e",
      color: "#fff",
      borderRadius: "8px",
      padding: "20px",
      width: "480px",
      boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
      display: "flex",
      flexDirection: "column",
      gap: "14px",
      position: "relative",
    },
    header: {
      fontSize: "18px",
      fontWeight: "bold",
    },
    closeBtn: {
      position: "absolute",
      top: "10px",
      right: "12px",
      background: "transparent",
      border: "none",
      color: "#ccc",
      fontSize: "18px",
      cursor: "pointer",
    },
    inputArea: {
      minHeight: "80px",
      borderRadius: "6px",
      border: "1px solid #333",
      backgroundColor: "#121212",
      padding: "10px",
      color: "#fff",
      fontSize: "14px",
      outline: "none",
      width: "100%",
    },
    tagContainer: {
      display: "flex",
      flexWrap: "wrap",
      gap: "6px",
      marginBottom: "10px",
    },
    tag: {
      backgroundColor: "#2d2d2d",
      color: "#fff",
      padding: "5px 10px",
      borderRadius: "12px",
      fontSize: "13px",
      display: "flex",
      alignItems: "center",
      gap: "6px",
    },
    removeBtn: {
      cursor: "pointer",
      background: "transparent",
      border: "none",
      color: "#ccc",
      fontWeight: "bold",
    },
    footer: {
      display: "flex",
      justifyContent: "flex-end",
      marginTop: "10px",
      gap: "10px",
    },
    laterBtn: {
      backgroundColor: "transparent",
      border: "1px solid #333",
      color: "#ccc",
      padding: "8px 14px",
      borderRadius: "6px",
      cursor: "pointer",
    },
    inviteBtn: {
      backgroundColor: emails.length > 0 ? "#8b5cf6" : "#444",
      border: "none",
      color: emails.length > 0 ? "#fff" : "#888",
      padding: "8px 14px",
      borderRadius: "6px",
      cursor: emails.length > 0 ? "pointer" : "not-allowed",
      fontWeight: "bold",
    },
    placeholder: {
      color: "#666",
      fontSize: "14px",
    }
  };

  const validateEmail = (email) => {
    return /^\S+@\S+\.\S+$/.test(email);
  };

  const handleSubmit = async () => {
    if (!projectId || emails.length === 0) return;
    const invalidEmails = emails.filter(email => !validateEmail(email));
    if (invalidEmails.length > 0) {
      Swal.fire({
        position: "top-end",
        title: `Os seguintes emails são inválidos: ${invalidEmails.join(', ')}`,
        showConfirmButton: false,
        timer: 1800,
        background: '#27272A',
        color: '#fff',
      });
      return;
    }
    setLoading(true);
    try {
      await projectService.inviteMembers(projectId, emails, keycloak.token);
      Swal.fire({
        position: "top-end",
        title: "Membros convidados com sucesso!",
        showConfirmButton: false,
        timer: 2000,
        background: '#27272A',
        color: '#fff',
      });
      onClose();
    } catch (error) {
      Swal.fire({
        position: "top-end",
        title: error.message || 'Erro ao convidar membros.',
        showConfirmButton: false,
        timer: 1800,
        background: '#27272A',
        color: '#fff',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <button style={styles.closeBtn} onClick={onClose}>✕</button>
        <h2 style={styles.header}>Convidar membros para o projeto</h2>

        <InputTags
          value={emails}
          onChange={(e) => setEmails(e)}
          placeholder="Digite e pressione 'Enter' para adicionar novos emails."
        />

        <div style={styles.footer}>
          <button style={styles.laterBtn} onClick={onClose} disabled={loading}>
            Fazer depois
          </button>

          <button
            style={styles.inviteBtn}
            disabled={emails.length === 0 || loading}
            onClick={handleSubmit}
          >
            {loading ? 'Enviando...' : 'Convidar equipe'}
          </button>
        </div>
      </div>
    </div>
  );
};